# When the HTTP client may send a request AGAIN on its own.
#
# Retry exists for flaky networks and pods mid-roll, NOT for the server saying
# no. Two rules, each learned the hard way:
#
# 1. A server's deliberate answer is not retried. The axios-retry default
#    replayed ANY 5xx on GET/PUT/DELETE, so an application error (an aborted
#    cascadeOnDelete, a validation throw) was re-sent up to 10 times with
#    "Check Your Internet Connection" toasts burying the real error. Only a
#    proxy answering for an unavailable upstream (502/503/504) is retried.
#
# 2. A request that is NOT idempotent is not replayed by the transport
#    (card 6aa8b5d850645cd1c3e765b1). A network error does not mean the request
#    never arrived — the RESPONSE may be what was lost — and the old condition
#    returned true for every network error before it ever looked at the method.
#    So a POST that had already been applied was applied again, silently, up
#    to 10 times: in el-feet one wrong answer on tablet wifi was recorded two or
#    more times and walked the child backward to easier material. A caller that
#    can make its own POST safe to repeat opts in by sending an
#    `Idempotency-Key` header, which is the promise that a repeat is harmless;
#    otherwise the caller owns its retries, where it can decide what a repeat
#    means.
#
# 3. A GET answered `304 Not Modified` is re-asked (card 6aa8b67e50645cd1c3e76605).
#    Page XHRs never send conditional headers themselves; a raw 304 reaching
#    axios is the browser's HTTP cache surfacing its own revalidation, and a
#    second ask is answered in full.
#
# Plain CommonJS, no imports: axios-retry's network-error test is passed in, so
# a pin can drive this without a browser or the axios-retry package.
IDEMPOTENT_METHODS = ['get', 'head', 'options', 'put', 'delete']
PROXY_UNAVAILABLE = [502, 503, 504]

headerValue = (headers, name) ->
  return undefined unless headers?
  return headers.get(name) if typeof headers.get is 'function'
  for own key, value of headers when key.toLowerCase() is name.toLowerCase()
    return value
  undefined

isReplayable = (config) ->
  method = String(config?.method or 'get').toLowerCase()
  return true if method in IDEMPOTENT_METHODS
  key = headerValue config?.headers, 'Idempotency-Key'
  key? and String(key).length > 0

shouldRetryRequest = (error, {isNetworkError}) ->
  config = error?.config
  return false unless isReplayable config
  return true if isNetworkError(error)
  status = error?.response?.status
  method = String(config?.method or 'get').toLowerCase()
  return true if status is 304 and method in ['get', 'head']
  status in PROXY_UNAVAILABLE

module.exports = {shouldRetryRequest, isReplayable}
